import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext';

type Props = {
  children: ReactNode;
};

/** Signed in, and past the temporary password — nothing else is reachable
 *  before the one the admin handed over is replaced. */
export function ProtectedRoute({ children }: Props) {
  const { status, currentUser } = useAuth();
  const location = useLocation();

  if (status === 'unauthenticated') return <Navigate to="/login" replace />;
  if (currentUser?.allow_password_change && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
